import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import style from "./logoutComponent.module.css"

function LogoutComponent() {
 const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
    dispatch({ type: 'LOGOUT' });
    navigate('/login', { replace: true });
  };

  return (
    <div className={style.buttonLogOut}>
      <button type="button" className={`${style.buttonLogOut} btn btn-light`}   onClick={handleLogout}>Cerrar sesión</button>
    </div>
  );
}

export default LogoutComponent;
